export default __webpack_public_path__ + "static/media/8169 - Mala.35f1dbba.jpeg";